const CustomerStatus = {
  Active: "active",
  Deactivated: "deactivated",
  Deleted: "deleted",
  Blocked: "blocked",
};

export default CustomerStatus;
